import { ContentViewStyle } from '@levelapp/softfabric';
export default class ButtonImportFileWebViewStyle extends ContentViewStyle {
    constructor() {
        super(...arguments);
        this.hide = {
            opacity: 0,
            width: 1,
            height: 1,
            position: 'absolute',
        };
        this.container = {
            flexDirection: 'row',
            flex: 1,
        };
        this.button = {
            width: 100,
        };
    }
}
